import { arrayToObject, addUpdateItem, removeItem } from '../../../functions'
import * as actions from './actions'
import { createActionTypeReducer} from '../../../middleware'

const initialState = {
    items: {}
}

export const organisationReducer = createActionTypeReducer({}, {
    [actions.CREATE_ORGANISATION_SUCCESS]: (state, action) => ({ ...state, ...addUpdateItem(state, action) }),
    [actions.UPDATE_ORGANISATION_SUCCESS]: (state, action) => ({ ...state, ...addUpdateItem( state, action) }),
    [actions.DELETE_ORGANISATION_SUCCESS]: (state, action) => ({ ...removeItem( state, action ) }),
})

export const organisationsReducer = createActionTypeReducer(initialState, {
    [actions.GET_ORGANISATIONS_SUCCESS]: (state, action) => ({ ...state, items: arrayToObject(action.payload.items) }),
},
    (state, action) => {
        return {
            ...state,
            items: organisationReducer(state.items, action)
        }
    }
)


// WEBPACK FOOTER //
// ./src/App/Admin/Organisations/reducers.js